<template>
  <div class="discount-image absolute flex c-items-center">
    <p class="discount-image_text text-center font-bold text-white c-m-0 w-100">
      -<ProductPrice
        :price-first="priceWithoutDiscount - priceWithDiscount"
        :currency="currency"
      />
    </p>
  </div>
</template>

<script setup>
import ProductPrice from "@/components/products/ProductPrice.vue";

defineProps({
  priceWithoutDiscount: {
    type: Number,
    default: 0,
  },

  priceWithDiscount: {
    type: Number,
    default: 0,
  },

  currency: {
    type: String,
    default: '',
  },
})
</script>

<style lang="scss" scoped>
.discount-image {
  top: 15px;
  left: 15px;
  min-width: 6.2rem;
  height: 4.1rem;
  background-image: url('@/assets/svg/unused/discount-bubble.svg');
  background-size: contain;
  background-repeat: no-repeat;
  z-index: 99;

  .discount-image_text {
    font-size: 1em;
    padding: 0 0.5em;
  }
}

@media screen and (max-width: 420px) {
  .discount-image {
    min-width: 5.8rem;
    height: 4rem;

    .discount-image_text {
      font-size: 0.8rem;
    }
  }
}
</style>
